import { FC, useCallback, useMemo } from 'react';
import ButtonSwitcher, { IButtonSwitcherOption } from '../ButtonSwitcher/ButtonSwitcher';
import { LOCALES } from 'src/constants/main';
import { ILangTextValidation } from 'src/types/main';

interface IProps {
  language: LOCALES;
  validation?: ILangTextValidation;
  setLanguage: (btnLocale: LOCALES) => void;
  className?: string;
}

const LanguageButtonSwitcher: FC<IProps> = ({ language, validation, setLanguage, ...props }: IProps): JSX.Element => {
  const { enValid, arValid } = validation || {};

  const onSetLanguage = useCallback((option: IButtonSwitcherOption) => {
    setLanguage(option.key as LOCALES);
  }, []);

  const localesOptions = useMemo((): IButtonSwitcherOption[] => {
    return [
      { label: 'eng', key: LOCALES.EN, className: validation && !enValid ? 'color-red' : '' },
      { label: 'ar', key: LOCALES.AR, className: validation && !arValid ? 'color-red' : '' },
    ];
  }, [enValid, arValid]);

  return <ButtonSwitcher selected={language} options={localesOptions} onClick={onSetLanguage} className={props.className} />;
};

export default LanguageButtonSwitcher;
